<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__bottom">
        <div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9">
          <BackLink />
          <Section :section="this.sectionId" />
        </div>
        <Form
          :error="error"
          :formId="id"
          :formErrorMessage="errorMessage"
          @submit="submitFormQuestion">
          <CheckboxList
            :title="question"
            :hintText="hintText"
            :detailsTitle="detailsTitle"
            :detailsMessage="detailsMessage"
            :error="error"
            :errorMessage="errorMessage"
            :id="id"
          >
            <img src="App/dist/static/img/msk/diagram.png" alt="Body diagram"/>
            <div v-for="(option, index) in options" :key="index" class="grid-col grid-xsmall-12 grid-large-6">
              <div class="push__right">
                <div class="checkbox">
                  <input
                    class="checkbox__input"
                    :id="'check'+index"
                    name="check"
                    type="checkbox"
                    :value="{id: option.id, response: option.label}"
                    @change="checkAnswers"
                    v-model="form.answer"
                  />
                  <label class="label checkbox__label" :for="'check'+index">{{option.label}}</label>
                </div>
              </div>
            </div>

          </CheckboxList>
        </Form>
      </article>
    </div>
  </div>
</template>

<script>
import { dataService } from "../shared";

export default {
  components: {},
  name: "home",
  props: {
    title: String
  },
  data() {
    return {
      id: "",
      sectionId: null,
      question: "",
      hintText: "",
      error: false,
      errorMessage: "All fields are required",
      detailsTitle: "",
      detailsMessage: "",
      name: "",
      nextUrl: "",
      noSelectionUrl: "",
      options: [],
      form: {
        answer: [],
        other: null
      }
    };
  },
  created() {
    this.loadQuestion();
  },
  mounted() {
    this.loadAnswer();
  },
  methods: {
    changeValue: function(newValue) {
      this.form.answer = {
        id: this.options[newValue].id,
        resposne: this.options[newValue].response
      };
      this.nextUrl = this.options[newValue].destination;
      this.form.label = this.options[newValue].label;
    },
    submitForm() {
      if (this.validateResponses(this.options)) {
        this.logResponse();
        this.isValid();
            if (dataService.canShowSummary())
            {
                this.$router.push({ name: "summary" });
            }
            else
            {
                this.$router.push({ name: this.nextUrl.toLowerCase() });
            }
      } else {
        this.isNotValid();
      }
    },
    isValid() {
      this.error = false;
      this.errorMessage = "";
    },
    isNotValid() {
      this.error = true;
      setTimeout(() => {
        document.querySelector(".error-summary__link").focus();
      }, 0);
    },
    checkAnswers() {
      return this.validateResponses(this.options)
        ? this.isValid()
        : this.isNotValid();
    },
    submitFormQuestion() {
      this.submitForm(this.form);
    },
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.id = currentQuestion.id;
      this.sectionId = currentQuestion.sectionId;
      this.question = currentQuestion.question;
      this.hintText = currentQuestion.hintText;
      this.name = currentQuestion.responseId;
      this.options = currentQuestion.options;
      this.errorMessage = currentQuestion.errorMessage;
      this.detailsTitle = currentQuestion.detailsTitle;
      this.detailsMessage = currentQuestion.detailsMessage;
      this.noSelectionUrl = currentQuestion.noSelectionDestination;
    },
    validateResponses(options) {
      let destination = "";
      var i;
      for (i = 0; i < 28; i++) {
        if (document.getElementById("check" + i).checked) {
          destination = options[i].destination;
        } else {
          var index = dataService.findIndex(this.form.answer, i);
          if (index > -1) {
            this.form.answer.splice(index, 1);
          }
        }
      }

      this.nextUrl = destination;
      if (this.nextUrl == "") {
        if (this.noSelectionUrl == "")
        {
          this.errorMessage = "You must select an answer.";
          return false;
        } else {
          this.nextUrl = this.noSelectionUrl;
          return true;
        }
      } else {
        return true;
      }
    },
    loadAnswer() {
      let answers = [];
      let previousResponse = dataService.wasAnsweredBefore(this.id);
      if (previousResponse) {
        previousResponse.responses.forEach(function(r) {
          setTimeout(() => {
            document.getElementById("check" + r.responseId).checked = true;
          }, 300);
          answers.push({ id: r.responseId, response: r.response });
        });
      }
      this.form.answer = answers;
    },
    logResponse() {
      let response = {
        id: this.id,
        questionType: "Checkbox",
        responses: []
      };
      this.form.answer.forEach(function(selection) {
        let r = {
          responseId: selection.id,
          response: selection.response
        };
        response.responses.push(r);
      });
      dataService.logResponse(response);
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    }
  }
};
</script>